import React, { useState } from "react";
import {
  Row,
  Col,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";

import { amgImg1, amgImg2 } from "@/utils/images";
import { routes } from "@/utils/routes";
import Hero from "../generic/hero";
import { airmilesContest } from "@/utils/content";
import classes from "@/styles/contests/contests-main.module.css";
import Image from "next/image";
import { useIsMobile } from "@/hooks/useIsMobile";
import Link from "next/link";

const AirmilesContest = () => {
  const content = airmilesContest.en;
  const isMobile = useIsMobile();
  const [open, setOpen] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <>
      <h1>{content.title}</h1>
      <Hero hideSeeMore />
      <section className={classes.col2Sec1}>
        <Row>
          <Col xs={12} md={8}>
            <h2>{content.entering}</h2>
            <div className="d-flex align-items-center mb-3">
              <Col className="pe-0">
                <h3 className={classes.numberBullet}>1</h3>
              </Col>
              <Col xs={10} className="ps-0">
                <h3 className={classes.numberList}>{content.signUp}</h3>
              </Col>
            </div>
            <Row>
              <Col className="pe-0">
                <h3 className={classes.numberBullet}>2</h3>
              </Col>
              <Col xs={10} className="ps-0">
                <span>
                  <h3 className={`mt-2 ${classes.numberList}`}>
                    {content.linkYourCard}
                  </h3>
                  <p className="ps-3 fw-bold">{content.linkYourCardPara}</p>
                </span>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={4}>
            <div className="d-flex align-itens-center justify-content-center flex-wrap">
              <Image
                className="img-fluid"
                src={amgImg1}
                alt={amgImg1}
                height={200}
                width={350}
              />
              <p className="fw-bold w-75 text-center mx-auto mt-2">
                {content.imgFooter}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="my-5">
          <Col className="d-flex align-items-center" xs={12} sm={6} md={4}>
            <div className={isMobile ? "" : classes.borderRight}>
              <h5 className={classes.blueText}>
                {content.alreadyHaveAnAccount}
              </h5>
              <Link
                href={routes.login}
                className={`my-3 btn ${classes.btnBlue}`}
              >
                {content.linkNowBtnText}
              </Link>
            </div>
          </Col>
          <Col className="d-flex align-items-center" xs={12} sm={6} md={4}>
            <div className="w-100">
              <h5 className={classes.blueText}>
                {content.dontHaveShipvistaAccount}
              </h5>
              <Link
                href={routes.register}
                className={`my-3 btn ${classes.btnBlue}`}
              >
                {content.signUpBtnText}
              </Link>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <Image
              className="img-fluid"
              src={amgImg2}
              alt={amgImg2}
              height={200}
              width={300}
            />
          </Col>
        </Row>
        <div className="my-5">
          <h5>{content.details}</h5>
          <ul>
            {content.detailsList.map((d, i) => {
              return (
                <li key={i}>
                  <span className="fw-bold text-darkblue">{d.title}</span>&nbsp;
                  <span className="fw-bold">{d.list}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
      <section className={classes.darkBlueSection}>
        <h3 className="text-center fw-bold text-decoration-underline">
          {content.title2}
        </h3>
        {content.images.map((img, i) => (
          <div className="text-center my-5" key={i}>
            <Image
              className={`${classes.autoHeightImg} img-fluid`}
              src={img.url}
              alt={img.url}
              height={400}
              width={400}
            />
            <p className="mt-3 w-50 mx-auto">{img.desc}</p>
          </div>
        ))}
      </section>
      <section className="pt-5">
        <Accordion
          open={open}
          //@ts-ignore
          toggle={toggle}
        >
          <AccordionItem>
            <AccordionHeader targetId={(1).toString()}>
              {content.termsText}
            </AccordionHeader>
            <AccordionBody accordionId={(1).toString()}>
              <ul>
                {content.terms.list.map((t, i) => {
                  return (
                    <li key={i}>
                      <p className="fw-bold mb-1">{t.title}</p>
                      {t.para.map((p, j) => {
                        return (
                          <p className="mt-0" key={j}>
                            {p}
                          </p>
                        );
                      })}
                    </li>
                  );
                })}
              </ul>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </section>
    </>
  );
};

export default AirmilesContest;
